import { ThumbnailCollection } from '@/modules/file/thumbnailService'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ThumbnailState {
  thumbnails: object
}

const initialState: ThumbnailState = {
  thumbnails: {},
}

const thumbnailsSlice = createSlice({
  name: 'documentUpload',
  initialState,
  reducers: {
    setThumbnails(state, { payload }: PayloadAction<ThumbnailCollection[]>) {
      const thumbnails = { }
      payload.forEach((thumbnail) => { thumbnails[thumbnail.minioId] = thumbnail })
      return { ...state, thumbnails }
    },
  },
})

export const {
  setThumbnails,
} = thumbnailsSlice.actions
export default thumbnailsSlice.reducer
